export default "__VITE_ASSET__D7c_bRO___"